module.exports = __webpack_public_path__ + "img/PlaceHolderLandscape.a748e0f1.png";